import { AuthEndpoints, AuthEndpointsMapping } from './auth/auth.endpoints';
import { CMSEndpoints, CMSEndpointsMapping } from './cms/cms.endpoints';
import { DMSEndpoints, DMSEndpointsMapping } from './dms/dms.endpoints';
import { EndpointConfig } from './endpoint.model';
import { LOSEndpoints, LOSEndpointsMapping } from './los/los.endpoints';
export const endpoints: EndpointConfig[] = [
    ...AuthEndpoints,
    ...LOSEndpoints,
    ...DMSEndpoints,
    ...CMSEndpoints
]
export const EP = {
  ...AuthEndpointsMapping,
  ...LOSEndpointsMapping,
  ...DMSEndpointsMapping,
  ...CMSEndpointsMapping

}